import { connect } from "react-redux";
import UIFocusSwitch from "./UIFocusSwitch";
import { setUIViewModeFocus } from "./actions/ui";

const mapStateToProps = state => ({
  focused: state.ui.focused
});

const mapDispatchToProps = dispatch => ({
  onChange(mode) {
    dispatch(setUIViewModeFocus(mode));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(UIFocusSwitch);



// WEBPACK FOOTER //
// ./src/UIFocusSwitchContainer.js